import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../message/message.service';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
	selector: 'app-firsttimelogin',
	templateUrl: './firsttimelogin.component.html',
	styleUrls: ['../auth-layout/auth-layout.component.css'],
})
export class FirsttimeloginComponent implements OnInit {
	firstTimeLogin: any;
	userId: number;
	constructor(
		private auth: AuthenticationService,
		private form: FormBuilder,
		private ar: ActivatedRoute,
		private message: MessageService
	) {
		this.firstTimeLogin = this.form.group({
			password: '',
			passwordRepeat: '',
		});
	}

	ngOnInit(): void {
		document.body.classList.add('login-page');
		this.ar.queryParams.subscribe((params) => {});
	}

	ngOnDestroy() {
		document.body.classList.remove('login-page');
	}

	submitChange() {
		var formData: any = new FormData();
		formData.append('password', this.firstTimeLogin.get('password').value);
		formData.append(
			'passwordRepeat',
			this.firstTimeLogin.get('passwordRepeat').value
		);
		console.log('updatePassword');
		console.log(formData);
		this.auth.updatePassword(formData).subscribe(
			(data) => {
				this.message.sendMessage(data);
			},
			(error) => {
				console.log(error);
			}
		);
	}
}
